import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Notifications from '../../services/notifications';
import { compose } from '../../services/utilityFunctions';
import BasicPortlet from '../portlets/BasicPortlet';
import translate from '../translate';
import withCSRF from '../withCSRF';
import Carousel from '../carousel/Carousel';
import SignedDocumentsListItem from './SignedDocumentsListItem';
import { useGetZip } from '../../services/customHooks';

function SignedDocumentsList(props) {
  const { t, _csrf, filters } = props;

  const [isLoading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);

  const getZippedDocuments = useGetZip(
    t,
    _csrf,
    '/jobs/journey/documents/signed/list/download',
    '/jobs/journey/documents/signed/list/download/status/',
    'signed-documents-list',
    setLoading,
    filters,
  );

  useEffect(() => {
    let ignore = false;

    setLoading(true);
    axios
      .get('/api/journey/documents/signed/list', {
        params: {
          ...filters,
          populate: filters.journey ? 'owner' : 'journey',
        },
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
        },
      })
      .then(({ data }) => {
        if (!ignore) {
          setDocuments(data.data);
        }
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err);
      })
      .finally(() => {
        if (!ignore) {
          setLoading(false);
        }
      });

    return () => {
      ignore = true;
    };
  }, [filters]);

  if (!isLoading && documents.length === 0) return null;

  return (
    <BasicPortlet
      title={t('documents')}
      titleClass="m--font-primary upperCase-title"
      toolClass="btn btn-brand btn-sm"
      toolAnchor={getZippedDocuments}
      isButton
      disabled={isLoading}
      toolTitle={t('report.certificates.downloadAll')}
      showBtn={documents.length > 0}
    >
      <div id="signed-documents-list">
        <Carousel>
          {documents.length > 0 ? (
            documents.map(document => (
              <SignedDocumentsListItem key={document._id} file={document} />
            ))
          ) : (
            <div className="no-certificates-found">
              <span className="text">{t('report.documents.notFound')}</span>
            </div>
          )}
        </Carousel>
      </div>
    </BasicPortlet>
  );
}

SignedDocumentsList.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    journey: PropTypes.string,
    user: PropTypes.string,
    dateStart: PropTypes.number,
    dateEnd: PropTypes.number,
  }).isRequired,
};

const memoized = React.memo(compose(translate, withCSRF)(SignedDocumentsList));
memoized.displayName = 'SignedDocumentsList';
export default memoized;
